import React from 'react';
import PropTypes from 'prop-types';

import styles from './ProcessStepsView.less';

/**
 * 流程步骤条
 * ------------------------------------------------------------------
 * 2026-09-17：原先 6 处样式全写在 JSX 的 style 里、颜色是字面量，
 * 现已全部改为 less 类 + token；状态差异用类切换（done / pending），
 * 不再在 JSX 里写三元表达式决定颜色。
 */
const ProcessStepsView = ({ steps = [], title = '' }) => {
  return (
    <div className={styles.wrap}>
      <div className={styles.title}>{title}</div>

      <div className={styles.steps}>
        {Array.isArray(steps) && steps.length > 0 ? (
          steps.map((step, index) => {
            const done = (step?.status || '') === 'done';
            return (
              <div key={index} className={styles.step}>
                <div
                  className={`${styles.dot} ${done ? styles.dotDone : ''}`}
                />
                <div>
                  <div
                    className={`${styles.stepTitle} ${
                      done ? styles.stepTitleDone : ''
                    }`}
                  >
                    {step?.title || '--'}
                  </div>
                  {step?.subTitle && (
                    <div className={styles.stepSub}>
                      {step?.subTitle || '--'}
                    </div>
                  )}
                </div>
                {index < steps.length - 1 && (
                  <div
                    className={`${styles.connector} ${
                      done ? styles.connectorDone : ''
                    }`}
                  />
                )}
              </div>
            );
          })
        ) : (
          <div className={styles.empty}>暂无进度信息</div>
        )}
      </div>
    </div>
  );
};

ProcessStepsView.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      subTitle: PropTypes.string,
      status: PropTypes.oneOf(['done', 'pending']).isRequired,
    }),
  ),
  title: PropTypes.string,
};

ProcessStepsView.defaultProps = {
  steps: [],
  title: '',
};

export default ProcessStepsView;
